<template>
  <div>
    <div class="cnt-search container">
      <Search :modifyInput="modifyInput" />
    </div>
    <Data :toSearch="toSearch" />
  </div>
</template>

<script>
// import Title from "../../../components/private/Title";
import Search from "../../../components/input/Search.vue";
import Data from "./Data.vue";
export default {
  components: {
    // Title,
    Data,
    Search,
  },
  data() {
    return {
      toSearch: "",
    };
  },
  methods: {
    modifyInput: function(text) {
      this.toSearch = text;
    },
  },
};
</script>
<style scoped>
.cnt-search {
  margin: 30px 0;
  background: white !important;
}
</style>
